@if (isFetching()) {
  <div class="loading">Chargement...</div>
}

@if (!isFetching()) {
  <div class="fiche-container animate-fade-in">

    <!-- Header -->
    <div class="fiche-titlebar grid grid-cols-3 items-center pt-4 px-2 md:px-4">
      <div class="justify-self-start">
        <button (click)="onCancel()" class="flex items-center gap-2 text-stone-400 hover:text-primary-600 transition-colors cursor-pointer">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          <span class="text-[11px] font-bold uppercase tracking-wider">Retour aux réseaux sociaux</span>
        </button>
      </div>
      <div class="justify-self-center">
        <h1 class="page-title">{{ pageTitle }}</h1>
      </div>
      <div class="justify-self-end"></div>
    </div>

    @if (errorMessage()) {
      <div class="mx-2 p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
        <svg class="w-4 h-4 flex-shrink-0 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"/>
        </svg>
        {{ errorMessage() }}
      </div>
    }

    <form (ngSubmit)="onSave()">
      <div class="fiche-content-area space-y-6">

        <!-- Informations -->
        <div class="fiche-section">
          <div class="fiche-section-title">Informations</div>
          <div class="fiche-section-box">
            <div class="fiche-grid">

              <div class="fiche-field">
                <span class="fiche-label-fixed">Plateforme <span class="text-red-500">*</span></span>
                <select
                  [value]="formData().social_media_platform"
                  (change)="updateField('social_media_platform', $any($event.target).value)"
                  class="fiche-input">
                  <option value="" disabled>Choisir une plateforme</option>
                  @for (p of platforms; track p) {
                    <option [value]="p">{{ p }}</option>
                  }
                </select>
              </div>

              <div class="fiche-field full-width">
                <span class="fiche-label-fixed">URL <span class="text-red-500">*</span></span>
                <input type="url"
                  [value]="formData().social_media_url"
                  (input)="updateField('social_media_url', $any($event.target).value)"
                  maxlength="500" placeholder="https://..."
                  class="fiche-input" />
              </div>

              <div class="fiche-field">
                <span class="fiche-label-fixed">Ordre d'affichage</span>
                <input type="number"
                  [value]="formData().social_media_order"
                  (input)="updateField('social_media_order', +$any($event.target).value)"
                  min="0" placeholder="0"
                  class="fiche-input" />
              </div>

              <div class="fiche-field">
                <span class="fiche-label-fixed">Statut</span>
                <div class="flex items-center gap-3">
                  <label class="status-radio-label" [class.active]="formData().social_media_status === 'ACTI'">
                    <input type="radio" name="social_media_status" value="ACTI"
                      [checked]="formData().social_media_status === 'ACTI'"
                      (change)="updateField('social_media_status', 'ACTI')" class="hidden" />
                    <span class="w-2 h-2 rounded-full" [class]="formData().social_media_status === 'ACTI' ? 'bg-emerald-500' : 'bg-stone-300'"></span>
                    En ligne
                  </label>
                  <label class="status-radio-label" [class.active-inac]="formData().social_media_status === 'INAC'">
                    <input type="radio" name="social_media_status" value="INAC"
                      [checked]="formData().social_media_status === 'INAC'"
                      (change)="updateField('social_media_status', 'INAC')" class="hidden" />
                    <span class="w-2 h-2 rounded-full" [class]="formData().social_media_status === 'INAC' ? 'bg-amber-400' : 'bg-stone-300'"></span>
                    Hors ligne
                  </label>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="flex items-center justify-end gap-3 pt-2">
          <button type="button" (click)="onCancel()" [disabled]="isLoading()"
            class="px-5 py-2.5 border border-stone-200 text-stone-600 rounded-xl hover:bg-stone-50 disabled:opacity-50 transition-colors text-sm font-medium">
            Annuler
          </button>
          <button type="submit" [disabled]="isLoading()"
            class="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-600 text-white rounded-xl hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-semibold shadow-sm shadow-primary-600/10">
            @if (isLoading()) {
              <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            } @else {
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            }
            {{ isLoading() ? 'Enregistrement...' : (isEditMode ? 'Modifier' : 'Créer') }}
          </button>
        </div>

      </div>
    </form>
  </div>
}
